//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  BoundingBoxDTO,
  IntelligentProductTaggingLinkRequest,
} from '@apis/intelligent-product-tagging/intelligentProductTaggingApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const intelligentProductTaggingFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch('ipt_gateway', `/api/v1/ipt${endpoint}`, init);
};

/**
 * Records that a client linked a product to a bounding box
 *
 * POST /api/v1/ipt/link
 */
export const linkProductToBoundingBox = async (
  req: IntelligentProductTaggingLinkRequest,
  init?: RequestInit,
): Promise<BoundingBoxDTO> => {
  const res = await intelligentProductTaggingFetch(`/link`, {
    ...(init ?? {}),
    method: 'POST',
    body: JSON.stringify(req),
  });

  return res.json<BoundingBoxDTO>();
};
